import { createReducer } from './utils';
import { clearAbort, createAbort, ABORT_KEYS } from './utils/abortManager';
import {
  NAVIGATION_STATUS,
  NAVIGATION_LOADING,
  NAVIGATION_COMPLETED,
  NAVIGATION_PENDING,
  NAVIGATION_LAST,
  NAVIGATION_FAILURE,
  NAVIGATION_PROGRESS,
  NAVIGATION_ACCESS,
} from './constants';

const defaultState = {
  finished: false,
  loading: false,
  fetched: false,
  completed: {},
  pending: {},
  last: '-',
  progress: 0,
  navigationAccess: false,
  errorMessage: null,
};

// reducer

export const reducer = createReducer(defaultState, {
  [NAVIGATION_STATUS]: handleNavigationStatus,
  [NAVIGATION_LOADING]: handleNavigationLoading,
  [NAVIGATION_COMPLETED]: handleNavigationCompleted,
  [NAVIGATION_PENDING]: handleNavigationPending,
  [NAVIGATION_LAST]: handleNavigationLast,
  [NAVIGATION_PROGRESS]: handleNavigationProgress,
  [NAVIGATION_FAILURE]: handleNavigationFailure,
  [NAVIGATION_ACCESS]: handleNavigationAccess,
});

function handleNavigationLoading(state, action) {
  return {
    ...state,
    loading: true,
    progress: 0,
    completed: {},
    pending: {},
  };
}

function handleNavigationStatus(state, { payload: { newStatus } }) {
  return {
    ...state,
    loading: false,
    fetched: true,
    finished: newStatus,
  };
}

function handleNavigationCompleted(state, { payload: { newCompleted } }) {
  return {
    ...state,
    completed: newCompleted,
  };
}

function handleNavigationPending(state, { payload: { newPending } }) {
  return {
    ...state,
    pending: newPending,
  };
}

function handleNavigationLast(state, { payload: { newLast } }) {
  return {
    ...state,
    last: newLast,
  };
}

function handleNavigationProgress(state, { payload: { newProgress } }) {
  return {
    ...state,
    progress: newProgress,
  };
}

function handleNavigationFailure(state, { payload: { error } }) {
  return {
    loading: false,
    fetched: true,
    finished: false,
    last: '',
    completed: [],
    pending: [],
    errorMessage: error,
  };
}

function handleNavigationAccess(state, { payload: { response } }) {
  return {
    ...state,
    navigationAccess: response['message'] === 'User has access to this feature',
  };
}

// actions
export function getNavigationStatus() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    const {
      stores: { currentStore },
    } = getState();

    const signal = createAbort(ABORT_KEYS.NAVIGATION_STATUS);

    dispatch({ type: NAVIGATION_LOADING });

    try {
      const response = await dataSource.requestNavigationStatus({
        store: currentStore,
        include_aisle_info: true,
        signal,
      });

      const newStatus = response['nav_finished'];
      const newCompleted = {
        aisle: response['navigated_aisles'],
        total: response['navigated_aisles'].length,
      };
      const newPending = {
        aisle: response['pending_aisles'],
        total: response['pending_aisles'].length,
      };

      const newLast = response['last_aisle_nav'];
      if (newLast !== null) {
        dispatch({ type: NAVIGATION_LAST, payload: { newLast } });
      } else {
        dispatch({ type: NAVIGATION_LAST, payload: { newLast: '-' } });
      }

      const newProgress = (
        newCompleted.total /
        (newCompleted.total + newPending.total)
      ).toFixed(2);

      dispatch({ type: NAVIGATION_COMPLETED, payload: { newCompleted } });
      dispatch({ type: NAVIGATION_PENDING, payload: { newPending } });
      dispatch({ type: NAVIGATION_PROGRESS, payload: { newProgress } });
      dispatch({ type: NAVIGATION_STATUS, payload: { newStatus } });
      clearAbort(ABORT_KEYS.NAVIGATION_STATUS);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.log('getNavigationStatus error', error);
      dispatch({
        type: NAVIGATION_FAILURE,
        payload: { error },
      });
    }
  };
}
